import React, { Component, ComponentType, createContext } from 'react';
import { Omit } from 'react-router';
import { BundleData } from 'client/bundles/types';

export const AppData = createContext<BundleData>({} as any);

export interface AppDataProps {
    appData: BundleData;
}

export function withAppData<P extends AppDataProps>(ComposedComponent: ComponentType<P>) {
    return class extends Component<Omit<P, keyof AppDataProps>> {
        public render() {
            return (
                <AppData.Consumer>
                    {data => <ComposedComponent appData={data} {...this.props as any} />}
                </AppData.Consumer>
            );
        }
    };
}
